import React from "react";
import PropTypes from "prop-types";
import MiradorMenuButton from "mirador/dist/es/src/containers/MiradorMenuButton";
import dfgViewerLogo from "./images/dfgviewerLogoInverse.png";

//directs to dfg_viewer
const newPage = (props) => {
  const manifestId = props.manifestId;
  const presentation = manifestId.replace("manifest.json", "presentation.xml");
  const webpage =
    "https://dfg-viewer.de/show/?tx_dlf%5Bid%5D=" +
    encodeURIComponent(presentation) +
    "&no_cache=1";

  return window.open(webpage, "_blank");
};

const btn = (props) => (
  <MiradorMenuButton
    aria-label={props.t("title")}
    onClick={() => newPage(props)}
  >
    <img
      src={dfgViewerLogo}
      width={100}
    />
  </MiradorMenuButton>
);

newPage.propTypes = {
  manifestId: PropTypes.string.isRequired,
};
newPage.defaultProps = {
  manifestId: "http://dfg-viewer.de/",
};

export default btn;